import { createSlice } from '@reduxjs/toolkit';
export const appSlice = createSlice({
    name: 'appState',
    initialState: {
        tarjeta:[0]
    },
    reducers: {
        change_tarjeta: (state, action) => {
            state.tarjeta.push(action.payload);
        },
        clean_tarjeta: (state, action) => {
            state.tarjeta.splice(0);
        },
        
    }
});
export const { change_tarjeta, clean_tarjeta } = appSlice.actions;
export default appSlice.reducer;